import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
      toast.success('Email instruksi telah dikirim.');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Gagal mengirim email.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg-primary)', padding: '24px'
    }}>
      <div style={{ width: '100%', maxWidth: 420 }} className="slide-up">
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo_ngada.png" alt="Logo" style={{ width: 64, height: 64, marginBottom: 16 }} />
          <h1 style={{ fontSize: '1.5rem', fontWeight: 800, color: 'var(--text-primary)' }}>Lupa Password</h1>
          <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>Masukkan email Anda untuk menerima instruksi reset.</p>
        </div>

        <div className="card" style={{ padding: 32 }}>
          {!sent ? (
            <form onSubmit={handleSubmit}>
              <div className="form-group" style={{ marginBottom: 24 }}>
                <label className="form-label">Alamat Email</label>
                <input
                  type="email"
                  className="form-input"
                  placeholder="email@ngadakab.go.id"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary btn-lg" disabled={loading} style={{ width: '100%' }}>
                {loading ? <div className="spinner" style={{ width: 20, height: 20, borderWidth: 2 }} /> : 'Kirim Instruksi'}
              </button>
            </form>
          ) : (
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
              <div style={{ color: '#059669', marginBottom: 16 }}>
                <svg width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" style={{ margin: '0 auto' }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <p style={{ fontSize: '0.9375rem', color: 'var(--text-primary)', fontWeight: 600, marginBottom: 8 }}>Email Terkirim!</p>
              <p style={{ fontSize: '0.8125rem', color: 'var(--text-secondary)', marginBottom: 24 }}>
                Silakan periksa kotak masuk email Anda <strong>{email}</strong> (termasuk folder spam jika tidak ada).
              </p>
              <button onClick={() => setSent(false)} className="btn btn-ghost btn-sm">Coba email lain</button>
            </div>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Link to="/login" style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" /></svg>
            Kembali ke Halaman Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
